import {
  InformationCircleIcon,
  MegaphoneIcon,
} from '@heroicons/react/24/outline';

import { TextStyle } from '../../../DesignSystem/Feedback/TextStyle';
import { Tooltip } from '../../../DesignSystem/Feedback/Tooltip';
import { classNames } from '../../../DesignSystem/Utils/classNames';
import { getAnnouncementGradients } from '../../Web/Modals/AnnouncementCenterModal/gradientColors';

export type AnnouncementBannerProps = {
  title: string;
  color: string;
  description?: string;
  onAnnouncementDescriptionHover?: (args: AnnouncementBannerProps) => void;
};

export function AnnouncementBanner({
  color,
  title,
  description,
  onAnnouncementDescriptionHover,
}: AnnouncementBannerProps) {
  const gradients = getAnnouncementGradients();

  return (
    <div className={classNames('flex h-10 w-full')}>
      {color && (
        <div
          className={classNames(
            'flex h-full w-full items-center rounded-tl-lg rounded-tr-lg px-4',
            gradients.find((x) => x.name === color)?.className
          )}
        >
          <MegaphoneIcon
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mr-2 h-5 w-5"
          />
          <TextStyle
            variant="base-medium"
            className="line-clamp-1 flex-1 break-words text-gray-9"
          >
            {title}
          </TextStyle>

          {description && (
            <Tooltip
              side="bottom"
              contentClassName="z-10"
              tooltipText={description}
              textClassName="break-all"
            >
              <InformationCircleIcon
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="ml-2 h-5 w-5"
                onMouseEnter={() =>
                  onAnnouncementDescriptionHover?.({ color, title })
                }
              />
            </Tooltip>
          )}
        </div>
      )}
    </div>
  );
}
